import { jsx as _jsx } from "react/jsx-runtime";
import { FormattedMessage } from "react-intl";
var translate = function (id, values) {
    if (values === void 0) { values = {}; }
    return _jsx(FormattedMessage, { id: id, values: values });
};
export default translate;
